import React from 'react'
import QntmTable from './QntmTable'
import { useQntmStorageList } from 'src/Libs/installation-details/hooks/use-qntm-storage-list'

interface Props {
  installationId?: string
  deviceLinkId?: number
}

/**
 * Component that holds the Qntm tile for the hardware component section of system details.
 */
const QntmList: React.FC<Props> = ({ installationId, deviceLinkId }) => {
  const { data } = useQntmStorageList(installationId ?? '', deviceLinkId ?? 0)

  if (!installationId || !deviceLinkId) return null

  return <QntmTable qntm={data ?? []} />
}

export default QntmList
